<template>
    <div>
        <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader"></h3>
        <div>
            <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
                <el-form-item label="整改状态">
                    <el-select v-model="formInline.rectification_status" clearable filterable placeholder="请选择">
                        <el-option v-for="item in $store.state.zgStatus" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="handleQuery">查询</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div>
            <custom-table :data="tableData" border style="width: 100%">
                <custom-table-column fixed label="序号" type="index" width="50">
                </custom-table-column>
                <custom-table-column prop="activity_name" fixed label="活动名称" min-width="180px">
                </custom-table-column>
                <custom-table-column prop="target_name" label="整改对象" min-width="160px">
                </custom-table-column>
                <custom-table-column prop="rectification_status_text" label="整改状态" width="100px">
                </custom-table-column>
                <custom-table-column prop="hazard_level_text" label="隐患等级" width="100px">
                </custom-table-column>
                <custom-table-column prop="rectification_limit_date" label="限定整改日期" width="160px">
                </custom-table-column>
                <custom-table-column label="隐患图片" min-width="240px">
                    <template slot-scope="scope" v-if="scope.row.image">
                        <el-image v-for="(img, index) in scope.row.image.split(',')" :key="index"
                            style="width: 50px; height: 50px" :src="img" :preview-src-list="scope.row.image.split(',')">
                        </el-image>
                    </template>
                </custom-table-column>
                <custom-table-column prop="description" label="隐患描述" min-width="180px">
                </custom-table-column>
                <custom-table-column fixed="right" label="操作" width="120">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.rectification_status == 1" @click="handleCompelate(scope.row)"
                            type="text" size="small">整改完成申请</el-button>
                        <!-- <el-button @click="handleDelet(scope.row.id)" type="text" size="small">删除</el-button> -->
                    </template>
                </custom-table-column>
            </custom-table>
            <div class="pageLine">
                <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
            </div>
        </div>
        <el-dialog :close-on-click-modal="false" title="整改完成申请" :visible.sync="centerDialogVisible" width="546px">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
                <el-form-item label="整改描述" prop="rectification_desc">
                    <el-input type="textarea" v-model="ruleForm.rectification_desc" :rows="5" placeholder="请输入"
                        style="width:332px;"></el-input>
                </el-form-item>
                <el-form-item label="附件说明" prop="rectification_file" style="width:100%">
                    <Uploadd ref="uploadd" fileFieldNameIn="rectification_file" :isMultiple="true" btnTitle="点击上传文件"
                        @setFileList="setFileListMultiple" @delFile="delUpFile"></Uploadd>
                </el-form-item>
                <el-form-item style="margin-top:8px;width:100%;text-align:right;">
                    <el-button type="primary" @click="submitFormByFun('ruleForm', createMethod)">提交</el-button>
                    <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinValidate } from '@/assets/js/mixin/validate';
import { mixinUpload } from '@/assets/js/mixin/upload';

export default {
    name: 'equipmentInto',
    mixins: [mixinList, mixinValidate, mixinUpload],
    data() {
        return {
            formInline: {
                review_status: '',
                rectification_status: '',
            },
            activeName: '1',
            props: {
                emitPath: false
            },
            ruleForm: {
                id: '',
                rectification_desc: "",
                rectification_file: '',
            },
            rules: {
                name: [{ required: true, message: '请输入', trigger: 'blur' }],
                file_path: [{ required: true, message: '请上传' }],
            },
        };
    },
    components: {},
    created() {
    },
    mounted() {
    },
    methods: {
        handleCompelate(row) {
            this.centerDialogVisible = true
            this.ruleForm.id = row.id
        },
        handleTabClick(val) {
        },
        async getList() {
            let params = this.$until.deleteNullPrototype(this.formInline);
            params.page = this.$refs.pageChild.page;
            params.size = this.$refs.pageChild.size;
            let res = await this.$api.instance.interfaceServer('api/hazard-rectification/list', 'get', params);
            if (res.code == 0 && res.data) {
                this.tableData = res.data.data;
                this.total = res.data.total;
            }
        },
        async createMethod() {
            let params = this.$until.deleteNullPrototype(this.ruleForm);
            let res = await this.$api.instance.interfaceServer('api/hazard-rectification/submit', 'post', params);
            if (res.code == 0) {
                this.$message({
                    type: 'success',
                    center: true,
                    message: '提交成功！',
                });
                this.clearState();
            }
        },
        handleQuery() {
            this.$refs.pageChild.page = 1;
            this.getList();
        },
    },
};
</script>
<style lang="less" scoped>
@media screen and (max-width: 1000px) {
    .pageHeader {
        border-bottom: 0;
    }
     /deep/.header-info-icon {
        bottom: 18px;
    }
}
@media screen and (min-width: 1000px) {
    .pageHeader{
        display: none;
    }
}
.pageHeader:before {
    width: var(--width);

}
</style>